<template>
    <div class="rules-layout">
        <el-dialog
            :visible.sync="show"
            :show-close="isShowClose"
            width="720px"
            :modal="true"
            :close-on-click-modal="true"
        >
            <div class="rules-container">
                <div class="header">
                    <img loading="lazy"
                        class="close-btn cursorPoint"
                        v-lazy="require('../../assets/shop/close.png')"
                        @click="show=false"
                    />
                </div>
                <div class="rules-content" v-html="ruleContent"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            isShowClose: false,
            ruleContent: "",
        };
    },
    mounted() {
        //获取规则
        this.getData();
    },
    methods: {
        getData() {
            this.$http.get(this.$api.getClientMall).then(res => {
                if (res.code == 0) {
                    this.ruleContent = res.data.ruleContent;
                }
            });
        },
        toIndex() {
            this.$router.back()
        },
        openDialog() {
            this.show = true;
        },
        closeDialog() {
            this.show = false;
        },
    },
    watch: {
        show(n) {
            if (n) {
                this.getData();
            }
        }
    }
};
</script>
<style lang='scss' scoped>
.rules-layout {
    height: 100%;
    width: 100%;
    .rules-container {
        position: relative;
        .header {
            position: absolute;
            top: 0;
            width: 720px;
            height: 50px;
            .close-btn {
                float: right;
                top: 12px;
                right: 18px;
                width: 30px;
                height: 30px;
                transition: 1s;
            }
            .close-btn:hover {
                transform: rotate(180deg);
            }
        }
        .rules-content {
            padding: 15px 40px 40px;
            overflow: scroll;
            height: 640px;
        }
    }
}
    
::v-deep 
    .el-dialog__wrapper {
        // top: 150px;
        display: flex;
        align-items: center;

        .el-dialog {
            height: 720px;
            border-radius: 12px !important;
            .el-dialog__header {
                padding: 0 !important;
            }
            .el-dialog__body {
                padding: 0 !important;
            }
        }
    }
</style>